<template>
  <nav
    class="navbar is-fixed-top"
    :class="{
      'navbar--shrink': shrinked,
      'is-transparent': !shrinked,
      'navbar--dark': dark
    }"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="container">
      <div class="navbar-brand">
        <div class="navbar-item">
          <logo class="logo" :color="shrinked && !dark ? null : 'white'" />
        </div>
        <span
          role="button"
          class="navbar-burger"
          @click="toggleMenu"
          :class="{ 'is-active': menuExpanded }"
          aria-label="menu"
          aria-expanded="false"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </span>
      </div>
      <div class="navbar-menu" :class="{ 'is-active': menuExpanded }">
        <div class="navbar-start">
          <span
            :class="{ 'home-active': isHomeAndIsScrolledTo('hero') }"
            class="navbar-item link-to-home font--condensed"
            @click="goToHomeAndScrollTo('hero')"
            >Strona główna</span
          >
          <span
            :class="{ 'home-active': isHomeAndIsScrolledTo('tv') }"
            class="navbar-item link-to-home font--condensed"
            @click="goToHomeAndScrollTo('tv')"
            >Telewizja</span
          >
          <span
            :class="{ 'home-active': isHomeAndIsScrolledTo('internet') }"
            class="navbar-item link-to-home font--condensed"
            @click="goToHomeAndScrollTo('internet')"
            >Internet</span
          >
          <span
            :class="{ 'home-active': isHomeAndIsScrolledTo('contact') }"
            class="navbar-item link-to-home font--condensed"
            @click="goToHomeAndScrollTo('contact')"
            >Kontakt</span
          >
        </div>

        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable font--condensed">
            <a class="navbar-link is-arrowless">Panel użytkownika</a>

            <div class="navbar-dropdown" :class="{ 'is-boxed': !shrinked }">
              <router-link
                to="/messages"
                class="navbar-item"
                @click.native="$immediatelyScrollToTop"
                >Ogłoszenia</router-link
              >
              <router-link
                to="/program"
                class="navbar-item"
                @click.native="$immediatelyScrollToTop"
                >Program TV</router-link
              >
              <router-link
                to="/videos"
                class="navbar-item"
                @click.native="$immediatelyScrollToTop"
                >Materiały TV</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";

import Logo from "./Logo";

const SCROLL_TRESHOLD = 1;

export default {
  name: "navbar",

  components: {
    Logo
  },

  data() {
    return {
      scrolled: false,
      menuExpanded: false
    };
  },

  computed: {
    shrinked() {
      return this.scrolled || this.menuExpanded;
    },

    dark() {
      return ["videos", "video"].includes(this.$route.name) && this.darkMode;
    },

    ...mapState({
      homeActive: state => state.home.active,
      darkMode: state => state.videos.darkMode
    })
  },

  methods: {
    toggleMenu() {
      this.menuExpanded = !this.menuExpanded;
    },

    handleScroll() {
      this.scrolled = window.scrollY > SCROLL_TRESHOLD;
    },

    isHomeAndIsScrolledTo(step) {
      return this.homeActive === step && this.$route.name === "home";
    },

    async goToHomeAndScrollTo(step) {
      //if (this.$route.name !== "home") {
      await this.$router.push({
        path: "/home",
        query: { step }
      });
      //}

      // this.$scrollTo(`*[data-step="${step}"]`, 2000, {
      //   offset: -100
      // });

      this.menuExpanded = false;
    }
  },

  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    $route() {
      this.menuExpanded = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$font-size: 0.7rem;
$light-active: $info;

.navbar {
  background-color: $transparent;
  transition: 0.3s ease-in-out;
  border-bottom: $transparent;

  .logo {
    height: 1.5rem;
  }

  &-item,
  &-link {
    font-size: $font-size;
    user-select: none;
    cursor: default;
    color: $white;

    &:not(.router-link-active):not(.home-active) {
      cursor: pointer;
    }

    &.router-link-active,
    &.home-active {
      color: $light-active;
    }

    &:hover:not(.router-link-active):not(.home-active) {
      color: $primary;
      background-color: $transparent;
    }

    &.has-dropdown .navbar-link {
      background: transparent;
    }

    .navbar-dropdown {
      & > .navbar-item {
        color: $grey-light;

        &.router-link-active,
        &.router-link-active:hover,
        &.router-link-active:focus {
          color: $light-active;
        }

        &:hover:not(.router-link-active):not(.home-active) {
          color: $primary;
        }
      }
    }
  }

  .link-to-home:not(.router-link-active):not(.home-active) {
    cursor: pointer;
  }

  &-menu {
    @include until($desktop) {
      display: block;
      opacity: 0;

      position: absolute;
      left: 0;
      right: 0;

      transition: all 0.3s ease-in-out;
      pointer-events: none;

      &.is-active {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }

  &--shrink {
    background-color: $white-bis;
    border-bottom: solid 1px $grey-lighter;
    transition: 0.3s ease-in-out;

    .navbar-item,
    .navbar-link {
      color: $grey-light;

      &.router-link-active,
      &.home-active {
        color: $light-active;
      }

      .navbar-dropdown {
        & .navbar-item {
          &.router-link-active {
            color: $light-active;
          }
        }
      }
    }
  }

  &--dark {
    &.is-transparent {
      .navbar-menu {
        background: transparent;
      }
    }

    .navbar-menu {
      .navbar-item,
      .navbar-link {
        color: $grey-light;

        &.home-active,
        &.router-link-active {
          color: $white;
        }

        &:hover:not(.router-link-active):not(.home-active) {
          color: $primary;
        }
      }

      .navbar-dropdown {
        background: lighten($black-ter, 2);

        & > .navbar-item {
          &.router-link-active {
            color: $white;
          }

          &:hover:not(.router-link-active):not(.home-active) {
            background: transparent;
          }
        }
      }
    }

    &.navbar--shrink {
      background: lighten($black-ter, 2);
      border-color: darken($black-ter, 5);

      .navbar-item,
      .navbar-link {
        background: transparent;

        &.home-active,
        &.router-link-active {
          color: $white;
        }

        .navbar-dropdown {
          border-color: darken($black-ter, 5);

          .navbar-item {
            &.router-link-active {
              color: $white;
            }
          }
        }
      }

      @include touch {
        .navbar-menu {
          background: lighten($black-ter, 2);
        }
      }
    }
  }
}

// Fix Navbar dropdown not showing on Edge
@include desktop {
  .navbar-item {
    &.is-hoverable:hover {
      .navbar-dropdown {
        display: block;
      }
    }
  }

  .navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
}
</style>
